import { css } from '@emotion/react';
import { COLOR_PALETTE } from '@inflearn/ds-react';
import { useState } from 'react';
import { MY_URL } from '../../../../constants/urls';

export const GameButton = () => {
  const [isWallUp, setIsWallUp] = useState(false);
  const [clickLever, setClickLever] = useState(false);

  const handleWallClick = () => {
    setIsWallUp(!isWallUp);
    if (isWallUp) {
      // 벽이 내려올 때 레버도 리셋
      setTimeout(() => {
        setClickLever(false);
      }, 400);
    }
  };

  const handleLeverClick = () => {
    if (isWallUp && !clickLever) {
      setClickLever(true);
      setTimeout(() => {
        window.open(MY_URL.GAMES(), '_blank');
      }, 600);
    }
  };

  return (
    <div css={gameButtonWrapper}>
      <svg
        width="80"
        height="120"
        viewBox="0 0 80 120"
        xmlns="http://www.w3.org/2000/svg"
        style={{ overflow: 'visible' }}
        css={svgContainerStyle}
      >
        {/* 파인 배경 (레버 뒤) */}
        <rect
          x="0"
          y="0"
          width="60"
          height="60"
          fill={COLOR_PALETTE.gray[2]}
          rx="8"
          ry="8"
          css={backgroundStyle(isWallUp)}
        />

        {/* 스위치 이미지 */}
        <image
          href={
            clickLever
              ? `${process.env.NEXT_PUBLIC_CDN_URL}/public/games/switch_on.png?w=56`
              : `${process.env.NEXT_PUBLIC_CDN_URL}/public/games/switch_off.png?w=56`
          }
          x="2"
          y="0"
          css={switchImageStyle}
          onClick={handleLeverClick}
          style={{ cursor: isWallUp ? 'pointer' : 'default' }}
        />

        {/* 흰 벽 */}
        <rect
          x="0"
          y="0"
          width="60"
          height="60"
          rx="8"
          ry="8"
          fill="#ffffff"
          stroke={COLOR_PALETTE.gray[3]}
          strokeWidth="1"
          strokeDasharray="416"
          strokeDashoffset={isWallUp ? 0 : 416}
          css={wallStyle(isWallUp)}
          onClick={handleWallClick}
          className="wall-rect"
        />
      </svg>
    </div>
  );
};

const gameButtonWrapper = css({
  zIndex: 100,
  overflow: 'visible',
  '@media(max-width: 1200px)': {
    display: 'none',
  },
  marginTop: 20,
  marginRight: -20,
});

const svgContainerStyle = css({
  '&:hover': {
    fill: COLOR_PALETTE.gray[0],
  },
});

const backgroundStyle = (isVisible: boolean) =>
  css({
    opacity: isVisible ? 1 : 0,
    transition: 'opacity 0.4s ease-out 0.6s',
  });

const wallStyle = (isUp: boolean) =>
  css({
    transition: isUp
      ? 'stroke-dashoffset 0.6s ease-out, transform 0.6s ease-out 0.6s, fill 0.2s ease-out'
      : 'transform 0.6s ease-out, stroke-dashoffset 0.6s ease-out 0.6s, fill 0.2s ease-out',
    transform: isUp ? 'translateY(-60px)' : 'translateY(0)',
    pointerEvents: 'auto',
    cursor: 'pointer',

    '&:hover': {
      fill: COLOR_PALETTE.gray[0],
    },
  });

const switchImageStyle = css({
  transition: 'opacity 0.3s ease-out',
  pointerEvents: 'auto',
});
